import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Sede } from '../models/sede';
import { Compania } from '../models/compania';
import { CrearSedeDto } from '../models/crear-sede-dto';
import { BuscarSedeDto } from '../models/buscar-sede-dto';

@Injectable()
export class SedeService {

  private urlEndPointSede: string = environment.sedeEndPoint;

  constructor(private http: HttpClient) { }

  sedesPorCompaniaCiudad(idCompania: number, IdCiudad: number): Observable<Sede[]> {
    return this.http.get(this.urlEndPointSede + `compania/${idCompania}/ciudad/${IdCiudad}`).pipe(
      map((respuesta) => respuesta as Sede[]),
    );
  }

  listarSedes(): Observable<Sede[]> {
    return this.http.get(this.urlEndPointSede + 'listar').pipe(
      map((respuesta) => respuesta as Sede[]),
    );
  }

  crearSede(crearSedeDto: CrearSedeDto): Observable<CrearSedeDto> {
    return this.http.post(this.urlEndPointSede + 'crear',
    crearSedeDto, {responseType: 'json'}).pipe(
      map((respuesta) => respuesta as CrearSedeDto),
    );
  }

  buscarSedes(idCiudad: number, nombreSede: string, idCompanias: number[]): Observable<BuscarSedeDto[]> {
    return this.http.get(this.urlEndPointSede + 'buscar/' + idCiudad +
    '/' + nombreSede + '/' + idCompanias).pipe(
      map((respuesta) => respuesta as BuscarSedeDto[])
    );
  }

  editarSede(sedeDto: BuscarSedeDto): Observable<BuscarSedeDto> {
    return this.http.post(this.urlEndPointSede + 'editar', sedeDto, {responseType: 'json'}).pipe(
      map((respuesta) => respuesta as BuscarSedeDto)
    );
  }
  
  sedesPorCiudad( IdCiudad: number): Observable<Sede[]> {
    return this.http.get(this.urlEndPointSede + `porIdciudad/${IdCiudad}`).pipe(
      map((respuesta) => respuesta as Sede[]),
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/sede.service.ts